import { Component, OnInit, OnDestroy, OnChanges, ViewChild, Input, SimpleChange, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { Pregunta } from '../_models/pregunta.model';
import { Respuesta } from '../_models/respuesta.model';
import { Solucion } from '../_models/solucion.model';

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";
import { CuestionarioService } from "../_services/cuestionario.service";

import {ConfirmDialogModule,ConfirmationService} from 'primeng/primeng';

declare var jQuery:any;

@Component({
  selector: 'respuesta',
  templateUrl: 'respuesta.template.html'
  //providers:  [PreguntasService]
})
export class RespuestaComponent  implements OnInit, OnDestroy, OnChanges {

  @Input() _respuesta: any;
  @Input() _contador: string;
  @Input() _id_cuestionario: number;
  @Input() _test: boolean;
  @Output() onBorrarRespuesta = new EventEmitter<number>();

  subscription: Subscription;

  respuesta: any;
  id_cuestionario: number = 0;
  test: boolean;
  contador: string;

  listapreguntas: Array<Pregunta> = [];

  pregunta_asociada: Array<any> = [];

  editando: boolean = false;
  desplegado: boolean = true;
  mostrarmodal: boolean = false;
  mostrarmodalpreguntas: boolean = false;
  soluciones_evi : any = [];

  id_pregunta_asociada: number = 0;

  constructor(private seguridad: SeguridadService,
              private router:Router,
              private globalEventsManager: GlobalEventsManager,
              private cuestionarioService: CuestionarioService,
              private confirmationService: ConfirmationService,
              private activatedRoute: ActivatedRoute){

  }

  ngOnInit(){

  }

  ngOnDestroy(){

  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){
    if (changes['_respuesta']){
      this.respuesta = changes['_respuesta'].currentValue;
      this.listapreguntas = this.respuesta.solucion_pregunta;
      this.pregunta_asociada = this.respuesta.solucion_pregunta_asociada;

      if (this.pregunta_asociada.length>0){
        this.id_pregunta_asociada = this.pregunta_asociada[0].id_pregunta;
      }

      this.editando = this.respuesta.editar;

      this.soluciones_evi = [];

      for (let i = 0; i < this.respuesta.solucion_evi.length; i++) {
        this.soluciones_evi.push(this.respuesta.solucion_evi[i].id_evidencia);
      }

      if (this.respuesta.respuesta == "" || this.respuesta.respuesta == null){

        this.respuesta.respuesta = "Respuesta vacía";
      }

      //console.log(this.respuesta);
      /*for (let i = 0; i < this.listapreguntas.length; i++){
        this.listapreguntas[i].id_respuesta = this.respuesta.id_respuesta;
      }*/

    }

    if (changes['_id_cuestionario']){
      this.id_cuestionario = changes['_id_cuestionario'].currentValue;
      this.respuesta.id_cuestionario = this.id_cuestionario;
    }

    if (changes['_test']){
      this.test = changes['_test'].currentValue;
      if (this.test){
        this.desplegado = false;
      }
    }

    if (changes['_contador']){
      this.contador = changes['_contador'].currentValue;
    }

  }

  pilaEvidencias(){
    this.globalEventsManager.setPilaEvidencias('');
  }

  onChangeModal(event){
    this.mostrarmodal = false;
    this.soluciones_evi = [];

    for (let i = 0; i < event.length; i++) {
      this.soluciones_evi.push(event[i].id_evidencia);
    }

    let envio: any;

    envio = {
      solucion_evi : this.soluciones_evi,
      id_respuesta: this.respuesta.id_respuesta,
      id_cuestionario: this.respuesta.id_cuestionario
    };

    this.cuestionarioService.setEvidencias(envio).subscribe(
      data => {
        if (data){
          //console.log(data.json().cuestionario);
          //this.updateArea(data);
          this.respuesta.solucion_evi = data.json().cuestionario;
          this.globalEventsManager.getEvidenciasSinRelacionar(this.id_cuestionario);
          this.globalEventsManager.getEvidenciasSinRelacionarCuestionario(this.id_cuestionario);

        }
      }
    );

    console.log(this.soluciones_evi);

  }

  onChangeModalPreguntas(event){

    this.mostrarmodalpreguntas = false;

    this.id_pregunta_asociada = event.id_pregunta_asociada;
    if (this.id_pregunta_asociada == 0){
      //quito la pregunta asociada
      this.respuesta.solucion_pregunta_asociada = [];

    }else{

      let pregunta = {
        id_pregunta: this.id_pregunta_asociada,
        pregunta: event.pregunta
      }
      this.respuesta.solucion_pregunta_asociada = [];
      this.respuesta.solucion_pregunta_asociada.push(pregunta);

    }


    this.pregunta_asociada = this.respuesta.solucion_pregunta_asociada;

    console.log(event);

  }

  onBorrarPregunta(event){

    //elimino la pregunta
    let pregunta: any;

    pregunta = {
      id_pregunta : event,
      id_respuesta : this.respuesta.id_respuesta,
      id_cuestionario: this.respuesta.id_cuestionario
    };

    this.cuestionarioService.deletePregunta(pregunta).subscribe(
      data => {
        if (data){

          let encontrado : number;

          for (let i = 0; i < this.listapreguntas.length; i++){
            if (this.listapreguntas[i].id_pregunta == event){
              encontrado = i;
            }
          }

          this.listapreguntas.splice(encontrado,1);

          this.globalEventsManager.getEvidenciasSinRelacionar(this.id_cuestionario);

        }
      }
    );

  }

  anadirPregunta(){

    let encontrado: boolean = false;

    for (let pregunta of this.listapreguntas){

      if (pregunta.id_pregunta == 0){
        encontrado = true;
      }

    }

    if (!encontrado){

      let nuevapregunta = new Pregunta();

      nuevapregunta.pregunta = "pregunta nueva";
      nuevapregunta.nivel = 1;
      nuevapregunta.editar = true;
      nuevapregunta.id_respuesta = this.respuesta.id_respuesta;

      this.listapreguntas.push(nuevapregunta);
    }

  }


  editar(){
    if (!this.test){
      this.editando = true;
      setTimeout(() => this.focus(), 50);
    }
  }

  focus(){
    jQuery("#input_respuesta_"+this.respuesta.id_respuesta).focus();
  }

  guardar(){

    if (this.editando){

      this.editando = false;

      //this.respuesta.solucion_evi = this.soluciones_evi;

      //console.log(this.respuesta);

      let respuesta: any;

      respuesta = {
        id_respuesta : this.respuesta.id_respuesta,
        respuesta: this.respuesta.respuesta,
        solucion_evi: this.respuesta.solucion_evi,
        solucion_pregunta: this.respuesta.solucion_pregunta,
        id_tipo: 1,
        id_pregunta: this.respuesta.id_pregunta,
        id_cuestionario: this.respuesta.id_cuestionario
      };

      console.log(respuesta);

      this.cuestionarioService.setRespuesta(respuesta).subscribe(
        data => {
          if (data){
            console.log(data.json());

            let al: any = {
              "texto" : "Cuestionario guardado",
              "mostrar": true
            };
            this.globalEventsManager.setAlert(al);

            //this.updateArea(data);
            //this.respuesta.solucion_evi = data.json().cuestionario;
            this.respuesta.id_respuesta = data.json().cuestionario.id_respuesta;

          }
        }
      );

    }

  }

  ver(id: string){
    this.desplegado = true;
    jQuery("#respuesta_"+id).slideDown('fast');
  }

  ocultar(id: string){
    this.desplegado = false;
    jQuery("#respuesta_"+id).slideUp('fast');
  }

  abrirModal(){
    this.mostrarmodal = true;
    this.editando = true;
  }

  abrirModalPreguntas(){
    this.mostrarmodalpreguntas = true;
    this.editando = true;
  }

  borrar(){
    this.onBorrarRespuesta.emit(this.respuesta.id_respuesta);
  }

  confirmBorrar() {
      this.confirmationService.confirm({
          message: '¿Seguro que deseas eliminar la respuesta?',
          accept: () => {
              this.borrar();
          }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/cuestionario/respuesta.component.ts